<!-- <div class="css-Combo_Default combo_default">
    <p class="css-Etiqueta etiqueta">{{descripcion_etiqueta}}</p>
    <select [ngModel]="model_value" class="css-select_Combo select_combo" name="select_combo"
        (ngModelChange)="onInputChange($event)" placeholder="Seleccione">
        <option value="" disabled selected="selected">{{combo_placeholder}}</option>
        <option *ngFor="let opcion of opciones" [value]="opcion.value">
            {{ opcion.texto }}
        </option>
    </select>
</div> -->

<div class="css-combo-1 combo">
    <label *ngIf="descripcion_etiqueta"
        class="css-label_combo_default-1 label_combo_default">{{descripcion_etiqueta}}</label>
    <div class="css-agrupador_mensajes_seleccion-1 agrupador_mensajes_seleccion">
        <select [id]="id" class="css-select_combo_default-1 select_combo_default" [(ngModel)]="modelValue"
            (ngModelChange)="onInputChange($event)">
            <option *ngFor="let opcion of opciones" [value]="opcion.value">
                {{ opcion.texto }}
            </option>
        </select>
        <div *ngIf="mensaje_ayuda" class="css-mensaje_ayuda_combo-1 mensaje_ayuda_combo">
            <p class="css-texto_mensaje_ayuda_combo-1 texto_mensaje_ayuda_combo">Lorem ipsum dolor sit amet</p>
        </div>
        <div *ngIf="mensaje_error" data-wcfid="mensaje_error_combo"
            class="css-mensaje_error_combo-1 mensaje_error_combo">
            <!-- Instance of sub-component comp-icon-mensaje-error -->
            <app-mensaje-error [mensaje_error]="mensaje_error"></app-mensaje-error>
        </div>
    </div>
</div>